import React, { 
    useState, 
    useEffect,
    useRef
} from 'react';
import { 
    Card, 
    Row, 
    Col 
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import axios from 'axios';
import useIsMounted from 'ismounted';

import RegistroProposta from './RegistroProposta';
import RegistroEmissao from './RegistroEmissao';
import RegistroCotacao from './RegistroCotacao';
import FiltroDataCabecalho from './FiltroDataCabecalho';
import GraficoBarrasFunil from './GraficoBarrasFunil';
import ComboResponsavel from './../../Componentes/ComboResponsavel';
import GerarRelatorioXls from './GerarRelatorioXls';
import GraficoSeguradorasFunil from './GraficoSeguradorasFunil';
import styles from './index.module.scss';
import Funil from './Funil';

// componente
export default function FunilVendas(){

    const seguradorasRef = useRef([]);

    // estados
    const isMounted = useIsMounted();
    const [carregando, alterarCarregando] = useState(true);
    const [consulta, alterarConsulta] = useState(null);
    const [funil, alterarFunil] = useState(null);
    const [parametros, alterarParametros] = useState({
        data: moment().format('YYYY-MM-DD'),
        id_responsavel: null
    });
    const [consultaRegistros, alterarConsultaRegistros] = useState(null);
    const [etapaConsulta, alterarEtapaConsulta] = useState(null);
    const [carregandoConsulta, alterarCarregandoConsulta] = useState(false);
    const [mostrarSugestao, alterarMostrarSugestao] = useState(true);
    const [dadosEtapaAtual, alterarDadosEtapaAtual] = useState({
        etapa: null,
        todas: false
    });

    // faz uma consulta sobre os registros relacionados ao filtro
    function registrosFiltro(etapa, todas = false) {
        alterarEtapaConsulta(etapa);
        alterarMostrarSugestao(true);

        // se não for todas, remove registros atual
        if(!todas) alterarConsultaRegistros(null);

        // altera etapa atual
        alterarDadosEtapaAtual({
            etapa,
            todas
        });

        // verifica a etapa para buscar as fichas
        switch(etapa){
            case 'cotacao': consultarCotacoesMes(); break;
            case 'proposta': consultarPropostasMes(todas); break;
            case 'emitido': consultarEmissaoMes(); break;
            case 'renovacao': consultarRenovacoes(); break;
            case 'emitidoCancelado': consultarEmissoesCanceladas(); break;
        }
        
    }

    // faz a consulta
    async function consultarFunil(idsSeguradoras=null) {

        // faz a consulta
        alterarCarregandoConsulta(true);

        // inicia
        try {

            // prepara parametros para consultar
            const params = {
                ...parametros
            };

            // caso estiver filtrando por seguradoras
            if(idsSeguradoras && idsSeguradoras.length > 0) {
                params['ids_seguradoras'] = idsSeguradoras;
            }

            // faz a requisição
            const { data } = await axios.get(`/relatorios/funil`, {
                params
            });

            // se ainda estiver renderizado
            if(isMounted.current) {
                // pega o primeiro registro
                alterarFunil(data.registros[0]);

                // resgata consulta
                let seguradorasConsulta = data.seguradoras;

                // caso estiver filtrando por seguradora
                if(params.ids_seguradoras && data?.seguradoras?.length > 0) {
                    // percorre seguradoras
                    seguradorasConsulta = data.seguradoras.map(s => {
                        // resgata os ids que esta filtrando
                        const ids = params.ids_seguradoras;

                        // verifica se mostra
                        s.show = ids.includes(s.dados.id);

                        // retorna seguradora
                        return s;
                    });
                }

                // monta objeto da consulta atualizada
                const consultaAtualizada = {
                    ...data,
                    seguradoras: seguradorasConsulta
                };

                // altera consulta
                alterarConsulta(consultaAtualizada);

                // encerra o carregamento
                alterarCarregando(false);

                // altera referencia das seguradoras
                seguradorasRef.current = consultaAtualizada.seguradoras;
                
                // retorna a consulta atualizada
                return consultaAtualizada;
            }

        } catch({ response }) {
            console.error(response);
        } finally {
            alterarCarregandoConsulta(false);
        }

    }    

    // busca as fichas
    async function consultarPropostasMes(todas){
        alterarCarregandoConsulta(true);

        // faz a consulta
        try {

            // prepara parametros
            const params = {
                ano: moment(parametros.data).format('YYYY'),
                mes: moment(parametros.data).format('MM'),
                id_responsavel: parametros.id_responsavel,
                data: parametros.data,
                todas: todas ? 'S' : 'N'
            }

            // caso estiver filtrando por seguradoras
            if(seguradorasRef.current && seguradorasRef.current.length > 0) {
                // resgata os ids das seguradoras
                const idsSeguradoras = seguradorasRef.current.filter(s => s.show).map(s => s.dados.id);

                // adiciona ids das seguradoras nos parametros
                if(idsSeguradoras.length > 0) {
                    params['ids_seguradoras'] = idsSeguradoras;
                }
            }

            // requisição
            const { data } = await axios.get(`/relatorios/funil/propostas`, {
                params
            });

            // finaliza consulta
            alterarConsultaRegistros(data.propostas);            
            
            // se já está mostrando todas, esconde sugestão
            if(todas) alterarMostrarSugestao(false);
        } catch({ response }) {
            console.error(response);
        } finally {
            alterarCarregandoConsulta(false);
        }
    }
    
    // consulta as emissões do mes
    async function consultarEmissaoMes() {
        // inicia carregamento
        alterarCarregandoConsulta(true);

        // faz a consulta
        try {

            const params = {
                ano: moment(parametros.data).format('YYYY'),
                mes: moment(parametros.data).format('MM'),
                id_responsavel: parametros.id_responsavel
            }
            
            // caso estiver filtrando por seguradoras
            if(seguradorasRef.current && seguradorasRef.current.length > 0) {
                // resgata os ids das seguradoras
                const idsSeguradoras = seguradorasRef.current.filter(s => s.show).map(s => s.dados.id);
                
                // adiciona ids das seguradoras nos parametros
                if(idsSeguradoras.length > 0) {
                    params['ids_seguradoras'] = idsSeguradoras;
                }
            }
            
            // requisição
            const { data } = await axios.get(`/relatorios/funil/emissoes`, {
                params
            });

            // pega os dados
            alterarConsultaRegistros(data.emissoes);            
        } catch({ response }) {
            console.error(response);
        } finally {
            alterarCarregandoConsulta(false);
        }
    }

    // consulta as renovações
    async function consultarRenovacoes() {
        alterarCarregandoConsulta(true);

        // faz a consulta
        try {

            // prepara parametros
            const params = {
                id_responsavel: parametros.id_responsavel
            }

            // caso estiver filtrando por seguradoras
            if(seguradorasRef.current && seguradorasRef.current.length > 0) {
                // resgata os ids das seguradoras
                const idsSeguradoras = seguradorasRef.current.filter(s => s.show).map(s => s.dados.id);

                // adiciona ids das seguradoras nos parametros
                if(idsSeguradoras.length > 0) {
                    params['ids_seguradoras'] = idsSeguradoras;
                }
            }

            // requisição
            const { data } = await axios.get(`/relatorios/funil/renovacoes`, {
                params
            });

            // finaliza
            alterarConsultaRegistros(data.renovacoes);            
        } catch({ response }) {
            console.error(response);
        } finally {
            alterarCarregandoConsulta(false);
        }

    }

    // consulta as cotações do mês
    async function consultarCotacoesMes() {
        alterarCarregandoConsulta(true);

        // faz a consulta
        try {

            // requisição
            const { data } = await axios.get(`/relatorios/funil/cotacoes`, {
                params: {
                    ano: moment(parametros.data).format('YYYY'),
                    mes: moment(parametros.data).format('MM'),
                    id_responsavel: parametros.id_responsavel
                }
            });
            
            // dados
            alterarConsultaRegistros(data.cotacoes);            

        } catch({ response }) {
            console.error(response);
        } finally {
            alterarCarregandoConsulta(false);
        }
    }
    
    // consulta as emissões que foram canceladas
    async function consultarEmissoesCanceladas() {
        alterarCarregandoConsulta(true);

        // faz a consulta
        try {

            // prepara parametros
            const params = {
                ano: moment(parametros.data).format('YYYY'),
                mes: moment(parametros.data).format('MM'),
                id_responsavel: parametros.id_responsavel
            }

            // caso estiver filtrando por seguradoras
            if(seguradorasRef.current && seguradorasRef.current.length > 0) {
                // resgata os ids das seguradoras
                const idsSeguradoras = seguradorasRef.current.filter(s => s.show).map(s => s.dados.id);

                // adiciona ids das seguradoras nos parametros
                if(idsSeguradoras.length > 0) {
                    params['ids_seguradoras'] = idsSeguradoras;
                }
            }

            // requisição
            const { data } = await axios.get(`/relatorios/funil/emissoesCanceladas`, {
                params
            });

            // pega os dados
            alterarConsultaRegistros(data.emissoesCanceladas);            

        } catch({ response }) {
            console.error(response);
        } finally {
            alterarCarregandoConsulta(false);
        }

    }
    
    // inicializa
    useEffect(() => {
        consultarFunil();
    }, [parametros]);

    if(carregando) {
        return <div>Carregando ...</div>
    }
    
    return (
        <>
            <Row>
                <Col>
                    <FiltroDataCabecalho 
                        value={parametros.data}
                        onChange={novaData => {
                            parametros.data = novaData;
                            alterarParametros({...parametros});
                        }}
                        carregando={carregandoConsulta}
                    />
                </Col>
                <Col lg={4}>
                    <Card
                        className={'border-0 shadow-sm'}
                    >
                        <Card.Body
                            className={'p-1'}
                        >
                            <div
                                className='d-flex'
                            >
                                <div
                                    className='flex-grow-1 mr-2'
                                >
                                    <ComboResponsavel 
                                        id={parametros.id_responsavel}
                                        alterou={idNovo => {
                                            parametros.id_responsavel = idNovo;
                                            alterarParametros({...parametros});
                                        }}
                                    />
                                </div>

                                <GerarRelatorioXls 
                                    parametros={parametros}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col lg='7'>                              
                    <Card className='border-0 shadow-sm mb-4'>
                        <Card.Body>
                            <small>Últimos 6 meses</small>
                            <GraficoBarrasFunil 
                                dados={consulta.registros}
                            />
                        </Card.Body>
                    </Card>

                    <Card className='border-0 shadow-sm'>
                        <Card.Body>
                            {(consultaRegistros === null && carregandoConsulta) && 
                                <p className='text-center'>
                                    <FontAwesomeIcon className='icone mr-2' pulse icon={['fas', 'spinner']} />
                                    <span>Carregando os registros</span>
                                </p>
                            }

                            {(consultaRegistros === null && !carregandoConsulta) &&
                                <p className='text-center'>
                                    Escolha uma das opções do funil para carregar
                                </p>
                            }

                            {(consultaRegistros !== null && consultaRegistros.length === 0) &&
                                <p className='text-center'>
                                    Sem resultados!
                                </p>
                            }

                            {(consultaRegistros && etapaConsulta === 'cotacao') &&
                                <>
                                    <h5>Cotações - {consultaRegistros.length}</h5>
                                    <hr />
                                    <div className={styles.registros}>
                                        { consultaRegistros.map(registro => 
                                            <RegistroCotacao 
                                                key={registro.dados.id}
                                                dados={registro.dados}
                                                cliente={registro.cliente}
                                                className={styles.registro}
                                            />
                                        )}
                                    </div>
                                </>
                            }

                            {(consultaRegistros && etapaConsulta === 'proposta') &&
                                <>  
                                    <h5>Propostas - {consultaRegistros.length}</h5>
                                    <hr />
                                    <div className={styles.registros}>
                                        {consultaRegistros.map(registro => 
                                            <RegistroProposta 
                                                key={registro.dados.id}
                                                dados={registro.dados}
                                                cliente={registro.cliente}
                                                proposta={registro.proposta}
                                                parcelasProposta={registro.parcelasProposta}
                                                className={styles.registro}
                                            />
                                        )}
                                    </div>

                                    { (mostrarSugestao && parseInt(funil.totalPropostas) >= 1) &&
                                        <button 
                                            className={[styles.linkCarregarMais, 'text-right mt-3 w-100'].join(' ')}
                                            disabled={carregandoConsulta}
                                            onClick={() => {
                                                registrosFiltro('proposta', true);
                                            }}
                                        >
                                            { carregandoConsulta &&
                                                <FontAwesomeIcon className='icone mr-2' pulse icon={['fas', 'spinner']} />
                                            }
                                            { parseInt(funil.totalPropostas) > 1 ?
                                                <small>Carregar todas as {funil.totalPropostas} propostas dos meses anteriores?</small>
                                                :
                                                <small>Carregar a proposta dos meses anteriores?</small>
                                            }
                                            
                                        </button>
                                    }
                                </>
                            }

                            {(consultaRegistros && (etapaConsulta === 'emitido' || etapaConsulta === 'renovacao' || etapaConsulta === 'emitidoCancelado')) &&
                                <> 
                                    <h5>
                                        { etapaConsulta === 'emitido' && 'Emissões'}
                                        { etapaConsulta === 'renovacao' && 'Renovações'}
                                        { etapaConsulta === 'emitidoCancelado' && 'Emissões canceladas'}
                                        <span> - {consultaRegistros.length}</span>
                                    </h5>
                                    <hr />
                                    <div className={styles.registros}>
                                        {consultaRegistros.map(registro => 
                                            <RegistroEmissao 
                                                key={registro.dados.id}
                                                dados={registro.dados}
                                                cliente={registro.cliente}
                                                emissao={registro.emissao}
                                                parcelasEmissao={registro.parcelasEmissao}
                                                className={styles.registro}
                                                etapaConsulta={etapaConsulta}
                                            />
                                        )}
                                    </div>
                                </>
                            }
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg='5'>
                    <Card className='border-0 shadow-sm mb-4'>
                        <Card.Body>
                            <Funil 
                                cotacao={funil.totalCotacaoMes}
                                renovacao={`${funil.totalRenovacao}`}
                                proposta={`${funil.totalPropostas} (${funil.totalPropostasMes})`}
                                emitido={funil.totalEmissaoMes}
                                emitidoCancelado={funil.totalEmissaoCanceladaMes}                                
                                totalLiquido={funil.totalLiquido}
                                alterouEtapa={etapaValor => {
                                    registrosFiltro(etapaValor);
                                }}
                            />
                        </Card.Body>
                    </Card>

                    <Card className='border-0 shadow-sm mb-4'>
                        <Card.Body>
                            <small>Emissões por seguradoras</small>
                            <GraficoSeguradorasFunil 
                                registros={consulta.seguradoras}
                                retornaNovasSeguradoras={async (seguradoras) => {
                                    // resgata id da seguradora
                                    const ids = seguradoras.map(ns => ns.id);

                                    // verifica e aplica o filtro
                                    if(ids.length > 0) {
                                        // espera fazer a consulta do funil com as seguradoras filtradas
                                        await consultarFunil(ids.length === consulta.seguradoras.length ? null : ids);

                                        // caso já tenha consultado uma etapa, faz a consulta com as seguradoras filtradas
                                        if(dadosEtapaAtual.etapa) {
                                            registrosFiltro(dadosEtapaAtual.etapa, dadosEtapaAtual.todas);
                                        }
                                    }
                                }}
                            />
                        </Card.Body>
                    </Card>                
                </Col>
            </Row>
        </>
    )

}